export const collectionSliderEventsConfig = {
    parentSelector: '.collection-icon-wrapper', // Parent selector specific to the slider container
    events: {
        // Collections | click on collection in collection slider (CSV Line 70)
        collectionIconSliderItemClick: {
            selector: '.collection-icon__slider .collection-icon__item__info a',
            event: {
                event: 'collections',
                component: 'collection_slider',
                element: 'item',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const collectionName = element.textContent.trim();
                    return {
                        collection_name: collectionName,
                        link_url: element.href
                    };
                }
            }
        },

        // Collections | click on slider button (CSV Line 71)
        collectionIconSliderButtonClick: {
            selector: '.collection-icon__slider-button.slider-button', // Corrected selector for prev/next buttons
            event: {
                event: 'collections',
                component: 'collection_slider',
                element: 'button',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    // No specific dynamic data requested in CSV for this generic button click
                    // We could add 'action_value: element.name' (next/previous) if needed
                })
            }
        }
    }
}; 